/**
 * Hook to track engagement time (time spent on page) in Google Analytics 4
 */

import { useEffect, useRef } from "react";
import { trackEngagementTime } from "../utils/analytics";

/**
 * Hook that tracks time spent on the current page
 * Sends engagement time every 30 seconds
 *
 * Usage: Add useEngagementTime() to any page component
 */
export function useEngagementTime(): void {
  const startTimeRef = useRef<number>(Date.now());
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    startTimeRef.current = Date.now();

    // Track engagement time every 30 seconds
    intervalRef.current = setInterval(() => {
      const timeSpent = Math.floor((Date.now() - startTimeRef.current) / 1000);
      if (timeSpent >= 30) {
        trackEngagementTime(timeSpent);
      }
    }, 30000); // Check every 30 seconds

    // Track final engagement time when component unmounts
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      const finalTimeSpent = Math.floor(
        (Date.now() - startTimeRef.current) / 1000
      );
      if (finalTimeSpent >= 10) {
        // Only track if user spent at least 10 seconds
        trackEngagementTime(finalTimeSpent);
      }
    };
  }, []);
}
